import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Validator from '@/utils/Validator'

export default {
  name: 'Signin',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.pageTitle + ' | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  data () {
    return {
      loginId: '',
      password: '',
      processing: false
    }
  },
  beforeMount () {
    console.log('this.authorized', this.authorized)
    if (this.authorized) {
      this.$router.push({name: 'Home'})
    } else {
      this.resetPermission()
    }
  },
  computed: {
    ...mapState({
      requireSetup: state => state.signin.requireSetup,
      authorized: state => state.auth.authorized,
      requireChangePassword: state => state.auth.requireChangePassword,
      mfaConfirmedAt: state => state.auth.mfaConfirmedAt
    }),
    ...mapGetters({
      getMeta: 'meta/get'
    }),

    siteName() {
      return Constants.SiteInfo.name
    },
    pageTitle () {
      return 'ログイン'
    },

    // validate
    loginIdIsValid () {
      return Validator.validText(this.loginId)
    },
    passwordIsValid () {
      return Validator.validText(this.password)
    },
    formIsValid () {
      return this.loginIdIsValid &&
        this.passwordIsValid
    },
    disableConfirmButton () {
      if (this.processing) return true
      return !Validator.validText(this.loginId) ||
        !Validator.validText(this.password)
    },
    
    isDevelopMode () {
      return process.env.NODE_ENV === 'local'
    },
    devList () {
      const apiMode = window._API_.mode === 'network'
      let list = $.extend(true, [], Constants.UserRole)
      if (!apiMode) {
        list.push({
          code: 'setup',
          label: 'アカウント初期登録'
        })
      }
      return list
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      signin: 'auth/signin',
      setPreviousAuth: 'auth/setPreviousAuth',
      resetPermission: 'permission/reset',
      setFlag: 'signin/setFlag',
      showError: 'error/show'
    }),
    clickSignIn () {
      if (!this.formIsValid) return
      this.processing = true

      // ログイン
      this.signin({
        loginId: this.loginId,
        password: this.password
      })
        .then(res => {
          console.log('signin', res)
          this.processing = false

          console.log('requireChangePassword: ', this.requireChangePassword)

          const timestamp = (new Date()).getTime()
          const requireVerify = timestamp - this.mfaConfirmedAt > 1000 * 60 * 60 * 24
          console.log('requireVerify: ', requireVerify)
          
          // ChangePasswordがtrueの場合は、本パスワードの登録へ
          if (this.requireChangePassword) {
            // 本パスワードでのログインがあるので、仮パスワードのラベル変更
            this.setFlag(false);

            this.$router.push({
              name: 'SetupPassword'
            })

          // 前回2段階認証日時から24時間以上経っている場合、二段階認証へ
          } else if (requireVerify) {
            this.$router.push(
              this.$route.query.redirect ||
              {
                name: 'Verification'
                // name: 'Home'
              }
            )

          // ホームへ
          } else {
            this.setPreviousAuth()
            this.$router.push(
              this.$route.query.redirect ||
              {
                name: 'Home'
              }
            )
          }

        })
        .catch(error => {
          this.showError(error || null)
          this.processing = false
        })
    },

    clickDev (role) {
      const apiMode = window._API_.mode === 'network'
      switch (role) {
        case 'admin':
          this.loginId = apiMode ? process.env.VUE_APP_LOCAL_SYS_TANTOU_ID : 'admin'
          this.password = apiMode ? process.env.VUE_APP_LOCAL_SYS_TANTOU_PWD : 'xxxxxxxxxx'
          break
        case 'operator':
          this.loginId = apiMode ? process.env.VUE_APP_LOCAL_SVC_TANTOU_ID : 'operator'
          this.password = apiMode ? process.env.VUE_APP_LOCAL_SVC_TANTOU_PWD : 'xxxxxxxxxx'
          break
        case 'external':
          this.loginId = apiMode ? process.env.VUE_APP_LOCAL_CMS_TANTOU_ID : 'external'
          this.password = apiMode ? process.env.VUE_APP_LOCAL_CMS_TANTOU_PWD : 'xxxxxxxxxx'
          break
        case 'setup':
          this.loginId = 'setup'
          this.password = 'xxxxxxxxxx'
          break
      }
    }
  }
}